import CountUp from 'countup.js';
import ScrollReveal from 'scrollreveal';
import Component from '../../../scripts/utilities/component';

class NumberRoll extends Component {
    componentDidMount() {
        if (!window.sr) {
            window.sr = new ScrollReveal();
        }

        this.countItems = [...this.root.querySelectorAll('[data-ref="item-stat-value"]')];
        this.countDuration = 2.5; // seconds
        this.options = {
            useEasing: false,
            useGrouping: false,
            separator: ','
        };
        this.isMobile = window.matchMedia('screen and (max-width: 992px)').matches;

        if (this.isMobile) {
            this.countItems.forEach((el) => {
                this.startCountAnim(el);
            });
            return;
        }

        window.sr.reveal(this.countItems, {
            viewFactor: 1,
            mobile: false,
            afterReveal: (el) => {
                this.startCountAnim(el);
            }
        });
    }

    startCountAnim(item) {
        const countValue = item.getAttribute('count-value');
        const numAnim = new CountUp(
            item, // the DOM Node
            0, // Start Value
            countValue, // End Value
            0, // Decimal places
            this.countDuration, // count duration - how long you want it to take
            this.options
        );
        if (!numAnim.error) {
            numAnim.start();
        } else {
            console.error(numAnim.error);
        }
    }
}

export default NumberRoll;



// WEBPACK FOOTER //
// ./components/eng-ms-squad-stats/scripts/squad-stats.js